<template>
  <basic-container>
    <div class="bankmanageDetail">
      <div class="bankdetail_title">
        <div class="banktail_">
          <Details
            :detaildeta="detaildeta"
            :data="projectData"
            :mySelf="!isFinal && (userInfo.user_id == projectData.managerUser)"
            @edit="edit"
          />

          <Detaillist v-if="projectData.projectType == 1" :detaillist="basicInfo['refinancingaHeaderConfig']" :data="projectData" ></Detaillist>
          <Detaillist v-if="projectData.projectType == 2" :detaillist="basicInfo['loanInstitutionHeaderConfig']" :data="projectData" />
          <Detaillist v-if="projectData.projectType == 3" :detaillist="basicInfo['loanInstitutionHeaderConfigTwo']" :data="projectData" />
          <Detaillist v-if="projectData.projectType == 4" :detaillist="basicInfo['setTheGainHeaderConfig']" :data="projectData" />

          <div>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane class="activelabel" label="项目详情" name="first">
                <div class="bankmanageDetail">
                  <div class="bankdetail_title">
                    <div class="banktail_">
                      <!-- 融资租赁 -->
                      <div>
                        <div class="form_wrapper">
                          <div class="form_header">
                            <div class="form_header_name">项目信息</div>
                            <div class="form_header_remarks"></div>
                          </div>
                          <div class="form_content">
                            <div class="label_name">基本信息</div>
                            <div class="bankcontent">
                              <Detaillist
                                v-if="projectData.projectType == 1"
                                :detaillist="basicInfo['refinancingConfig']"
                                :data="projectData"
                              >
                                <template slot="fileName">
                                  <div v-if="fileList.length > 0">
                                    <template v-for="(item, index) in fileList">
                                      <div class="file_wrapper" :key= index>
                                        <a
                                          class="file_button"
                                          target="_blank"
                                          :href="
                                            isWord(item.fileUrl)
                                              ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' +
                                                item.fileUrl
                                              : item.fileUrl"
                                          type="text"
                                          size="small"
                                        >
                                          {{ item.fileName }}
                                        </a>
                                        <i
                                          @click="downLoadFile(item.id)"
                                          class="el-icon-download del_icon"
                                        ></i>
                                        <i
                                          v-if="userInfo.user_id == projectData.createUser"
                                          @click="delFile(item.id, index, 'file')"
                                          class="el-icon-circle-close del_icon"
                                        ></i>
                                      </div>

                                    </template>
                                  </div>

                                  <div class="file_wrapper" v-else>
                                    <span style="padding: 0 15px;color:#303133;">-</span>
                                  </div>
                                </template>
                              </Detaillist>
                              <Detaillist
                                v-if="projectData.projectType == 2"
                                :detaillist="basicInfo['loanInstitutionConfig']"
                                :data="projectData"
                              >
                                <template slot="fileName">
                                  <div v-if="fileList.length > 0">
                                    <template v-for="(item, index) in fileList">
                                      <div class="file_wrapper" :key= index>
                                        <a
                                          class="file_button"
                                          target="_blank"
                                          :href="
                                            isWord(item.fileUrl)
                                              ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' +
                                                item.fileUrl
                                              : item.fileUrl"
                                          type="text"
                                          size="small"
                                        >
                                          {{ item.fileName }}
                                        </a>
                                        <i
                                          @click="downLoadFile(item.id)"
                                          class="el-icon-download del_icon"
                                        ></i>
                                        <i
                                          v-if="userInfo.user_id == projectData.createUser"
                                          @click="delFile(item.id, index, 'file')"
                                          class="el-icon-circle-close del_icon"
                                        ></i>
                                      </div>

                                    </template>
                                  </div>

                                  <div class="file_wrapper" v-else>
                                    <span style="padding: 0 15px;color:#303133;">-</span>
                                  </div>
                                </template>                              
                              </Detaillist>
                              
                              <Detaillist
                                v-if="projectData.projectType == 3"
                                :detaillist="basicInfo['loanInstitutionConfigTwo']"
                                :data="projectData"
                              />                              
                              <Detaillist
                                v-if="projectData.projectType == 4"
                                :detaillist="basicInfo['setTheGainConfig']"
                                :data="projectData"
                              >
                                <template slot="fileName">
                                  <div v-if="fileList.length > 0">
                                    <template v-for="(item, index) in fileList">
                                      <div class="file_wrapper" :key= index>
                                        <a
                                          class="file_button"
                                          target="_blank"
                                          :href="
                                            isWord(item.fileUrl)
                                              ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' +
                                                item.fileUrl
                                              : item.fileUrl"
                                          type="text"
                                          size="small"
                                        >
                                          {{ item.fileName }}
                                        </a>
                                        <i
                                          @click="downLoadFile(item.id)"
                                          class="el-icon-download del_icon"
                                        ></i>
                                        <i
                                          v-if="userInfo.user_id == projectData.createUser"
                                          @click="delFile(item.id, index, 'file')"
                                          class="el-icon-circle-close del_icon"
                                        ></i>
                                      </div>

                                    </template>
                                  </div>

                                  <div class="file_wrapper" v-else>
                                    <span style="padding: 0 15px;color:#303133;">-</span>
                                  </div>
                                </template>                              
                              </Detaillist>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane class="activelabel" label="附件信息" name="second">
                <Accessory
                  :idname="fileName"
                  :fileMenuUrlname="fileMenuName"
                  :upload="permission.zg_upload && (userInfo.user_id == projectData.managerUser)"
                  :projectid="projectData['id']"
                />                
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
      <div></div>
    </div>
    <template><router-view :key="fullpath"></router-view></template>
  </basic-container>
</template>

<script>
import Accessory from "@/components/accessoriesother/accessory";
import Details from "@/components/detail/contract_currency/detail";
import Detaillist from "@/components/detail/contract_currency/detaillist";

import * as api from "@/api/zg/zg";
import Item from "./components/items.vue";
import { mapGetters } from "vuex";
import { basicInfo } from "./components/config.js";
import * as dictionaries from "@/api/zd/dictionaries";

export default {
  name: "detail",
  
  data() {
    return {
      baFileMenuId: '',
      activeName: "first",
      projectData: {},
      butshengheloading: false,
      examine: true,
      auditVisible: false,
      auditForm: {
        auditAdvise: null,
      },
      detaildeta: {
        edit: "permission.zg_edit",
        // add: "permission.fdoffunds_add",
        // audit: "permission.fdoffunds_audit",
        title: "data.name"
      },
      basicInfo:basicInfo(),
      basicInfoData: [],
      isFinal: false,
      fileName: '',
      fileMenuName: '',
      fileList: []
    };
  },
  components: {
    Accessory,
    Details,
    Detaillist,
    Item,
  },
  watch: {
    $route(to, from) {
      this.openPage()
    },
    activeName: {
      handler(newName, oldName) {
        if (newName == "third") {
          this.queryEventList();
        }
      },
    },
    projectData:{
      handler(newName, oldName) {
        this.basicInfo = basicInfo(newName,this.getMoney)
      }
    }
  },
  created() {
    this.openPage()
  },
  computed: {
    ...mapGetters(["permission", "userInfo"]),
    fullpath: function () {
      return this.$route.query.fullpath;
    },
     
  },
  methods: {
    // 通过文件夹名称获取菜单
    getFileMenuByNames() {
      let self = this
      dictionaries.getFileMenuByName({ fileMenuName:'项目管理相关文件' }).then((res) => {
        self.baFileMenuId = res.data.data.id
        let params = {
          fileOtherId: self.$route.params.id,
          baFileMenuId: self.baFileMenuId
        }
        dictionaries.findFileByOtherId(params).then(fileRes => {
          if(fileRes['data']['data']['length'] > 0){
            self.fileList = fileRes['data']['data']
            // self.data['fileName'] = fileRes['data']['data']
          }else{
            self.fileList = []
            // self.data['fileName'] = []
          }
        })
      })
      .catch((res) => {
        console.log(res);
      });
    },

    openPage(){
      this.id = this.$route.params.id;
      if(this.$route.query.type && this.$route.query.type == 'final'){
        this.isFinal = true
      } else {
        this.isFinal = false
      }
      this.onLoad();
    },
    //获取详情
    onLoad() {
      let self = this
      api
        .getDetail({id:this.id})
        .then((res) => {
          this.$nextTick(() => {
            this.projectData = res.data.data
            self.dealData()
          });
        })
        .catch((res) => {
          console.log(res);
        });
    },

    // 按照项目类型处理数据
    dealData() {
      let projectType = this.projectData.projectType
      if(projectType != 3) this.getFileMenuByNames()
      this.projectData.peojectTypeTran = Number(this.projectData.projectType) == 1?'转融通':
                                          Number(this.projectData.projectType) == 2?'委托贷款':
                                          Number(this.projectData.projectType) == 3?'信托':'定增'
      this.fileName = this.isFinal?'项目收尾':'项目管理'
      // 处理还款期限
      let creditDateStr = ''
      if(projectType == 2 || projectType == 3){
        let dateList = projectType == 2?this.projectData.projectEntrustLoans.creditDateList:this.projectData.projectFinancialLoans.creditDateList
        creditDateStr = projectType == 2?`${this.projectData.projectEntrustLoans.creditBeginDate}始`:`${this.projectData.projectFinancialLoans.creditBeginDate}始`
        if(dateList.length > 0){
          dateList.map((item,index) => {
            creditDateStr += ` 至 ${item.creditEndDate}还款${Number(item.repayAmount).toFixed(2)}万元`
            if(index != dateList.length - 1){
              creditDateStr += '，'
            }
          })
        } else {
          creditDateStr = '-'
        }
      }

      switch(Number(projectType)){
        case 1:
            this.fileMenuName = '资产管理'
            this.projectData.name = this.projectData.name
            this.projectData.arrTran = `${(Number(this.projectData.projectRefinancing.arr)*100).toFixed(4)}%`
            this.projectData.lendingDayPriceTran = `${Number(this.projectData.projectRefinancing.lendingDayPrice).toFixed(2)}元`
            this.projectData.interestTran = `${(Number(this.projectData.projectRefinancing.interest)).toFixed(2)}元`
            this.projectData.compensationTran = `${(Number(this.projectData.projectRefinancing.compensation)).toFixed(2)}元`

            this.projectData.securitiesNumTran = `${this.projectData.projectRefinancing.securitiesNum}万股`
            this.projectData.realLendingDaysTran = `${this.projectData.projectRefinancing.realLendingDays}天`
          break;
        case 2:
            this.fileMenuName = '资产管理2'
            this.projectData.arrTran = (Number(this.projectData.projectEntrustLoans.arr)*100).toFixed(4)
            this.projectData.creditNumTran = Number(this.projectData.projectEntrustLoans.creditNum).toFixed(2)
            // this.projectData.creditTimeTran = `${this.projectData.projectEntrustLoans.creditBeginDate}-${this.projectData.projectEntrustLoans.createEndTime}`
            this.basicInfo.loanInstitutionHeaderConfig.column[3].url = `/zd/customer/detail/${this.projectData.custId}`
            this.basicInfo.loanInstitutionConfig.column[4].url = `/zd/customer/detail/${this.projectData.custId}`
            // 处理还款期限
            this.projectData.creditTimeStr = creditDateStr
          break;
        case 3:
            this.fileMenuName = '资产管理2'
            this.projectData.arrTran = (Number(this.projectData.projectFinancialLoans.arr)*100).toFixed(4)
            this.projectData.creditNumTran = Number(this.projectData.projectFinancialLoans.creditNum).toFixed(2)
            // this.projectData.creditTimeTran = `${this.projectData.projectFinancialLoans.creditBeginDate}-${this.projectData.projectFinancialLoans.createEndTime}`
            this.basicInfo.loanInstitutionHeaderConfigTwo.column[3].url = `/zd/customer/detail/${this.projectData.custId}`
            this.basicInfo.loanInstitutionConfigTwo.column[4].url = `/zd/customer/detail/${this.projectData.custId}`
            // 处理还款期限
            this.projectData.creditTimeStr = creditDateStr
          break;
        case 4:
            this.fileMenuName ='资产管理'
          break;
      }
    },

    // queryCompanyName() {
    //   let self = this
    //   api.getCompanyData({
    //     custType: 3,
    //     dictKey: this.projectData.custId
    //   }).then(res => {
    //     let data = res.data.data
    //   })
    // },

    //编辑
    edit(id) {
      this.$router.push({ path: `/zg/assetManageEdit/${id}` });
    },
  },
};
</script>

<style lang="scss" scoped>
.bankmanageDetail {
  .file_wrapper{
    padding:0px 15px 5px;
    color: #333;
    a{
      margin-right: 15px;
    }
    i{
      margin-right: 5px;
      cursor: pointer;
    }
  }  
  .bankdetail_title {
    background: #fff;
    padding-top: 25px;
    padding-bottom: 25px;
  }
  .history {
    position: absolute;
    top: 50%;
    right: 15px;
    display: flex;
    justify-content: center;
    z-index: 20;
    flex-direction: row;
    .history_content {
      width: 100px;
      font-size: 13px;
      cursor: pointer;
      height: 45px;
      display: flex;
      flex-direction: row;
      // justify-content: center;
      background: #409eff;
      line-height: 45px;
      color: #fff;
      // text-align: right;
      // padding-right: 15px;
      border-radius: 10px 0 0 10px;
      .imagehistory {
        text-indent: 5px;
        width: 35px;
        display: flex;
        justify-content: center;
        margin-right: 8px;
        flex: 1;
      }
      .text_history {
        flex: 2;
      }
    }
  }
  .banktail_ {
    width: 1000px;
    margin: 0 auto;
  }
  .bank_nameblock {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    .bankname {
      font-size: 18px;
      font-weight: bolder;
    }
    .changeblock {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      .historyclass {
        background: #19be6b;
        padding: 5px 10px;
        font-size: 10px;
        border-radius: 0 10px 10px 0;
        margin-right: 10px;
        color: #fff;
      }
      .reds {
        background: #f56c6c;
      }
      .orange {
        background: #fec03d;
      }
    }
  }

  .bankcontent {
    position: relative;
    margin: 20px 0;
    .el-col {
      margin-bottom: 0px;
    }
    .grid_content {
      line-height: 35px;
      color: #333333;
      font-size: 13px;
      // margin-bottom: 5px;
      .el-form-item {
        margin-bottom: 0px;
      }

      .banktitle_content {
        color: #999999;
        margin-right: 15px;
      }
      .shstate {
        display: flex;
        flex-direction: row;
        text-align: center;
        justify-content: right;
        .list_top {
          flex: 1;
        }
        .towlist_top {
          text-align: right;
        }
        // .list_top:nth-last-of-type(1){
        //  text-align: right;
        // }

        .stateTop {
          color: rgb(187, 185, 185);
          text-indent: 12px;
        }
        .stateTop + div {
          color: #666666;
          font-size: 20px;
        }
        .stateTopdiv::before {
          content: "";
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-right: 5px;
        }
      }
      .data_ {
        margin-top: 25px;
        text-align: right;
        .stateTop {
          color: rgb(187, 185, 185);
        }
        .stateTop + div {
          font-size: 20px;
          font-weight: bolder;
        }
      }
    }
  }
}

.bankstate_0:before {
  background: #fec03d;
}
.bankstate_1:before {
  background: #51d351;
}
.bankstate_2:before {
  background: #ff7a8c;
}

.auditState_0:before {
  background: #fec03d;
}
.auditState_1:before {
  background: #409eff;
}
.auditState_2:before {
  background: #51d351;
}
.auditState_3:before {
  background: #51d351;
}
.warningblock {
  cursor: pointer;
  color: rgb(197, 192, 192);
}
.box_card {
  width: 100%;
  box-shadow: 1px 1px 5px #ddd;
  margin: 20px 0;
  .demo-basic {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 13px;
  }
}
.autilog {
  display: flex;
  flex-direction: column;
}
.warningtext {
  color: rgb(197, 192, 192);
  font-size: 12px;
}
.bankmanageDetail .el-tabs__item.is-active {
  background: none;
}
.box_cards {
  height: 450px;
  overflow-y: auto;
}
.passblocksblock {
  // margin-top: 25px;
  text-align: right;
}

.checkcontract {
  cursor: pointer;
}
.detil_row {
  display: inline-block;
}
/deep/.el-form-item__label {
  color: #999999;
}
/deep/.el-tabs__header {
  margin: 0px;
}
.informationxm {
  margin-top: 20px;
}
.form_wrapper {
  height: 100%;
  margin: 0;
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(233, 233, 233, 1);
  border-radius: 10px;
  background-color: #fff;

  .form_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-width: 0px;
    height: 60px;
    background-color: rgba(249, 249, 249, 1);
    padding: 0 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: 1px rgba(233, 233, 233, 1) solid;

    .form_header_name {
      font-weight: 700;
      color: #333;
      font-size: 16px;
    }
    .form_header_remarks {
      color: #999999;
      font-size: 13px;
      .red_color {
        color: #ff3b30;
      }
    }
  }
  .form_content {
    padding: 20px 50px;
  }
}
.label_name {
  font-weight: 900;
  color: #666666;
  position: relative;
  margin: 30px 0;
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: -15px;
    transform: translate(0, -50%);
    height: 18px;
    width: 6px;
    background-color: #409eff;
  }
}
/deep/.banktail_ .el-tabs__item {
  font-size: 18px;
  font-weight: bolder;
  margin-bottom: 10px;
}
/deep/.avue-crud__menu {
  display: none;
}
/deep/.avue-crud {
  width: 100%;
}
/deep/.avue-crud .el-table th {
  background-color: #ffffff;
  line-height: 50px;
  padding: 0;
}
/deep/.el-table .cell,
.el-table th > .cell {
  padding-left: 20px;
}
/deep/.el-table__empty-block {
  border-right: none;
}
.card_dtInfor .cell {
  padding-left: 20px !important;
}
.card_dtInfor .el-table th {
  background: #fff !important;
}
.card_dtInfor .el-table,
.card_dtInfor .el-table__empty-block {
  border: none !important;
}
.card_dtInfor .el-table::before {
  height: 0 !important;
}
.box_card {
  border-bottom: 0px;
}
/deep/ .el-table th {
  background: #fff;
  color: #333;
}
.blue-word {
  color: #409eff;
  cursor: pointer;
}
</style>

